import PropTypes from 'prop-types';
import React from 'react';

/**
 * Touch-optimized button for TRC assessments.
 * Uses native <button> element for proper touch handling on iPad/mobile devices.
 * Based on ShapedButton but with better touch responsiveness.
 */
const TRCButton = ({ ariaLabel, styles, onClick, isEnabled, children, text }) => (
    <button
        type="button"
        aria-label={ariaLabel}
        className={styles}
        onClick={onClick}
        disabled={!isEnabled}
    >
        {children}
        {text !== '' && (
            <div className="button-text" aria-hidden={true}>
                {text}
            </div>
        )}
    </button>
);

TRCButton.propTypes = {
    ariaLabel: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
    text: PropTypes.string,
    styles: PropTypes.string,
    isEnabled: PropTypes.bool,
};

TRCButton.defaultProps = {
    ariaLabel: '',
    children: undefined,
    text: '',
    styles: '',
    isEnabled: true,
};

export default TRCButton;
